export default {
    namespaced: true,
        state: {
            showImportForm: false,
            onBehalfAccount: {
                id: auth.usergroup,
                name: auth.company
            },
    },
    mutations: {
        toggleShowForm(state, show) {
            state.showImportForm = show;
        },
        setOnBehalfAccount(state, account) {
            state.onBehalfAccount = account;
        }
    }
    };
